import React from 'react';

import { ReactComponent as SupportIcon } from '../../assets/images/icons/Support.svg';
import { Links } from '../../utils/constants';
import { LinkButton } from '../LinkButton';

import * as classes from './style.module.scss';

// todo: update wording and button
export const SupportBanner: React.FC = () => (
  <section className={classes.section}>
    <div className={classes.root}>
      <div className={classes.imagecontainer}>
        <SupportIcon className={classes.supportdesk} />
      </div>
      <div className={classes.container}>
        <div className={classes.headline}>
          Didn&#39;t find the answers you were looking for?
        </div>
        <div className={classes.subline}>
          Don&#39;t worry, we&#39;re always happy to help.
        </div>
        <LinkButton
          aria-label={Links.ContactSupport.name}
          href={Links.ContactSupport.url}
          className={classes.button}
        >
          {Links.ContactSupport.name}
        </LinkButton>
      </div>
    </div>
  </section>
);
